import {useHistory} from "react-router-dom";
import React, {useState, useEffect} from 'react';

function ErrorPage() {
    const history = useHistory();

    useEffect(function() {
        setTimeout(function () {
            BX24.fitWindow();
        }, 500)
    }, []);

    function handleNextClick() {
        history.push("/instruction");
        return false;
    }

    return (
        <div className="ErrorPage">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 text-center">
                        <img src="/img/error.png" alt="" />
                        <div className="subtitle">
                            Oops.... Произошла ошибка. Попробуйте заново.
                        </div>

                        <a href="#" className="button" onClick={handleNextClick}>
                            Попробовать заново
                        </a>

                        <div className="help">
                            Если ошибка повторится, свяжитесь с нами по <a target="_blank" href="mailto:bitrix24@severcode.ru">электронной почте</a>.
                        </div>

                    </div>

                </div>



            </div>
        </div>
    );
}

export default ErrorPage;
